"use strict";const t=require("react/jsx-runtime"),o=require("@mui/material"),i=({title:r,children:e})=>r?t.jsx(o.Tooltip,{placement:"top",arrow:!0,title:r||"",children:e}):e;module.exports=i;
